(function () {
  var CASTING_METHOD = '3D Scan';

  function rigidityFor(gender, size) {
    var cutoff = gender === 'Women' ? 12 : 10;
    return size >= cutoff ? 'Semi-Rigid' : 'Flex';
  }

  function applyDefaults() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pending = cart.items.filter(function (item) {
          return !item.properties || !item.properties['Insole Type'];
        });

        return pending.reduce(function (chain, item) {
          var gender = '';
          var size = 0;

          (item.options_with_values || []).forEach(function (opt) {
            if (opt.name === 'Gender') gender = opt.value;
            if (opt.name === 'Size') size = parseFloat(opt.value) || 0;
          });

          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.key,
                properties: {
                  'Insole Type': item.product_title,
                  'Casting Method': CASTING_METHOD,
                  'Rigidity': rigidityFor(gender, size)
                }
              })
            });
          });
        }, Promise.resolve());
      })
      .catch(function (err) {
        console.warn('Roam default specs:', err);
      });
  }

  // Catch adds made via fetch
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add') !== -1;

    return nativeFetch.apply(this, arguments).then(function (response) {
      if (isAdd && response.ok) applyDefaults();
      return response;
    });
  };

  // Catch adds made via XMLHttpRequest
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__roamIsAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return nativeOpen.apply(this, arguments);
  };

  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__roamIsAdd) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) applyDefaults();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  // Catch anything the interceptors miss (full page reload after add)
  document.addEventListener('DOMContentLoaded', applyDefaults);
})();